<ul class="filters">
  <!-- <li *ngIf="childs?.length > 0" routerLink="/{{plink}}">Presentacion</li> -->
  <li class="parent-header"><a routerLink="/{{parent_link}}">{{parent_title}}</a></li>
  <li *ngIf="childs.length==0">Cargando menú</li>
  <li *ngFor="let child of childs" routerLink="/{{child.link}}"  [routerLinkActive]="['active']">
    {{child.title}}
    <!-- <ul *ngIf="child.hasChild">
      <li *ngFor="let c of getChilds(child.id)"><h1>child</h1></li>
    </ul> -->
  </li>
</ul>
